import React, { useEffect, useState } from 'react';
import { Translation } from 'react-i18next';
import { Button, Card, Col, Row, Space, Spin } from 'antd';
import { LoadingOutlined, PlusCircleOutlined } from '@ant-design/icons';

import CareGuidesList from '../containers/CareGuidesListContainer';
import CareGuidesCSVButton from '../containers/CareGuidesCSVButtonContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import { pathTo } from '../../../Routes';
import Config from '../../../../../Config';
import QueryString from '../../../../../lib/QueryString';
import Logger from '../../../../../lib/Logger';
import CareGuideModalExport from '../containers/CareGuideModalExportContainer';
import CareGuideUploadCSVButton from '../containers/CareGuideUploadCSVButtonContainer';


const CareGuidesScreen = (props) => {
  const [openModalExport, setOpenModalExport] = useState(false);

  const limit = Config.get('DEFAULT_LIST_LENGTH', 10);

  const scrollToTop = () => {
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  const loadingIcon = (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />
  );

  const page = parseInt(props.match.params.page ? props.match.params.page : 1);
  const { order, ...filter } = QueryString.parse(props.location.search);

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <Translation>
      {(t) => (
        <div>
          <DocumentHead title={t('care_guides_route_list')} />

          <Row>
            <Col span={24}>
              <Card
                title={
                  <Space size={10}>
                    {t('care_guides_list_title')}
                    <Button
                      size="small"
                      icon={<PlusCircleOutlined />}
                      onClick={(e) =>
                        props.history.push(pathTo('CareGuideAddScreen'))
                      }
                    >
                      {t('action_create')}
                    </Button>
                    <CareGuidesCSVButton onClick={()=>{setOpenModalExport(true)}} />
                    <CareGuideUploadCSVButton/>

                  </Space>
                }
                extra={props.isLoading ? loadingIcon : null}
              >
                <CareGuidesList
                  key={page}
                  component="CareGuidesScreen"
                  page={page}
                  limit={limit}
                  order={order || 'updated_at.desc'}
                  filter={filter}
                />
              </Card>
            </Col>
          </Row>
          <CareGuideModalExport
            openModalExport={openModalExport}
            setOpenModalExport={setOpenModalExport}
            order={order}
            filter={filter}
          />
        </div>
      )}
    </Translation>
  );
};

export default CareGuidesScreen;

Logger.log('silly', `CareGuidesScreen loaded.`);
